module.exports = __webpack_public_path__ + "img/thumbnail_AlpineIbex_f_normal.a86d25fe.png";